import { render, staticRenderFns } from "./CultivationSummary.vue?vue&type=template&id=53a35db6&scoped=true&"
import script from "./CultivationSummary.vue?vue&type=script&lang=js&"
export * from "./CultivationSummary.vue?vue&type=script&lang=js&"
import style0 from "./CultivationSummary.vue?vue&type=style&index=0&id=53a35db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a35db6",
  null
  
)

export default component.exports